var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"show":_vm.show,"modalClasses":"modal-hide-footer"},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{staticClass:"card-table"},[_c('CommitmentScenario',{attrs:{"tables":_vm.tables,"isfull":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }